/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AppointAnIntermediaryViewModel,
  ErrorResult,
  NotFoundErrorResult,
  ResultOfAppointAnIntermediaryViewModel,
  ValidationErrorResult,
} from '../models';
import {
    AppointAnIntermediaryViewModelFromJSON,
    AppointAnIntermediaryViewModelToJSON,
    ErrorResultFromJSON,
    ErrorResultToJSON,
    NotFoundErrorResultFromJSON,
    NotFoundErrorResultToJSON,
    ResultOfAppointAnIntermediaryViewModelFromJSON,
    ResultOfAppointAnIntermediaryViewModelToJSON,
    ValidationErrorResultFromJSON,
    ValidationErrorResultToJSON,
} from '../models';

export interface AppointAnIntermediaryGetRequest {
    proposalId: number;
}

export interface AppointAnIntermediaryPostRequest {
    proposalId: number;
    appointAnIntermediaryViewModel: AppointAnIntermediaryViewModel;
}

/**
 * 
 */
export class AppointAnIntermediaryApi extends runtime.BaseAPI {

    /**
     * Gets the proposal\'s appoint an intermediary.
     */
    async appointAnIntermediaryGetRaw(requestParameters: AppointAnIntermediaryGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfAppointAnIntermediaryViewModel>> {
        if (requestParameters.proposalId === null || requestParameters.proposalId === undefined) {
            throw new runtime.RequiredError('proposalId','Required parameter requestParameters.proposalId was null or undefined when calling appointAnIntermediaryGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/appoint-intermediary/{proposalId}`.replace(`{${"proposalId"}}`, encodeURIComponent(String(requestParameters.proposalId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfAppointAnIntermediaryViewModelFromJSON(jsonValue));
    }

    /**
     * Gets the proposal\'s appoint an intermediary.
     */
    async appointAnIntermediaryGet(requestParameters: AppointAnIntermediaryGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfAppointAnIntermediaryViewModel> {
        const response = await this.appointAnIntermediaryGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Posts the specified proposal identifier.
     */
    async appointAnIntermediaryPostRaw(requestParameters: AppointAnIntermediaryPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfAppointAnIntermediaryViewModel>> {
        if (requestParameters.proposalId === null || requestParameters.proposalId === undefined) {
            throw new runtime.RequiredError('proposalId','Required parameter requestParameters.proposalId was null or undefined when calling appointAnIntermediaryPost.');
        }

        if (requestParameters.appointAnIntermediaryViewModel === null || requestParameters.appointAnIntermediaryViewModel === undefined) {
            throw new runtime.RequiredError('appointAnIntermediaryViewModel','Required parameter requestParameters.appointAnIntermediaryViewModel was null or undefined when calling appointAnIntermediaryPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/appoint-intermediary/{proposalId}`.replace(`{${"proposalId"}}`, encodeURIComponent(String(requestParameters.proposalId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AppointAnIntermediaryViewModelToJSON(requestParameters.appointAnIntermediaryViewModel),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfAppointAnIntermediaryViewModelFromJSON(jsonValue));
    }

    /**
     * Posts the specified proposal identifier.
     */
    async appointAnIntermediaryPost(requestParameters: AppointAnIntermediaryPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfAppointAnIntermediaryViewModel> {
        const response = await this.appointAnIntermediaryPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
